import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router";

import "./Patients.css";

import * as actions from "../../../store/actions";
import constants from "../../../constants";

import Tabs from "../../../components/uiElements/navTabs/Tabs";
import AllPatients from "./PatientList/AllPatients";
import MyPatients from "./PatientList/MyPatients";

const Patients = ({ match, history }) => {
  const { path } = match;

  let currentTab = history?.location?.pathname?.split("/")?.pop();
  currentTab = currentTab === "patients" ? "allPatients" : currentTab;

  const tabs = [
    {
      name: "allPatients",
      value: `All Patients`,
      to: path,
    },
    {
      name: "myPatients",
      value: `My Patients`,
      to: `${path}/myPatients`,
    },
  ];

  return (
    <div>
      <div className="appointment-container m-n4">
        <Tabs tabs={tabs} activeTab={currentTab} />
      </div>
      <div className="col-md-12 mt-5">
        <Route exact path={path} render={() => <AllPatients />} />

        <Route
          exact
          path={`${path}/myPatients`}
          render={() => <MyPatients />}
        />
      </div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  patients: dashboard?.patients,
});

const mapDispatchToProps = dispatch => ({
  getPatients: () =>
    dispatch(
      actions.getAppointments([
        constants.APPOINTMENT_STATUS.requested,
        constants.APPOINTMENT_STATUS.accepted,
      ])
    ),
  searchPatient: searchData => dispatch(actions.searchPatient(searchData)),
  getAllPatientList: () => dispatch(actions.getAllPatientList()),
  getMyPatients: () => dispatch(actions.getDoctorPatientList()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Patients);
